import { create } from 'zustand'
import { RemoteAgent } from '@/types'
import * as api from '@/services/api'

interface AgentState {
  agents: RemoteAgent[]
  isLoading: boolean
  isSubmitting: boolean
  error: string | null
  fetchAgents: () => Promise<void>
  registerAgent: (agentData: Partial<RemoteAgent>) => Promise<void>
}

const useAgentStore = create<AgentState>((set) => ({
  agents: [],
  isLoading: false,
  isSubmitting: false,
  error: null,

  fetchAgents: async () => {
    set({ isLoading: true, error: null })
    try {
      const agents = await api.getRemoteAgents()
      set({ agents, isLoading: false })
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to fetch remote agents.'
      set({ error: errorMessage, isLoading: false, agents: [] })
    }
  },

  registerAgent: async (agentData: Partial<RemoteAgent>) => {
    set({ isSubmitting: true, error: null })
    try {
      const newAgent = await api.registerRemoteAgent(agentData)
      set((state) => ({
        agents: [...state.agents, newAgent],
        isSubmitting: false,
      }))
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to register agent.'
      set({ error: errorMessage, isSubmitting: false })
      throw error
    }
  },
}))

export default useAgentStore
